import shortid from "shortid";
import generateUnitConds from "./generateUnitConds";

export default function normalizeFactorItems(factor: Factor) {
  if (!factor.Factor_Items) return [];
  const cond: Cond = {
    title: "currency",
    label: <span className="font-bold">{factor.Currency.en_title}</span>,
    value: "currency",
    type: "price",
  };
  const res: FactorProductRow[] = factor.Factor_Items.map((x) => {
    const unitConds = generateUnitConds({ val: x });
    return {
      id: shortid.generate(),
      productId: x.ProductId,
      discountInput: { val: x.discount/x.quantity, cond },
      taxInput: { val: x.tax/x.quantity, cond },
      price: x.price,
      constantPrice: x.price,
      product: x.Product,
      quantity: x.quantity,
      count: x.quantity,
      totalPrice: x.totalOneProduct,
      description: x.description,
      unit: x.unit,
      unitConds,
      warehouseId: x.warehouseId,
    };
  });
  return res;
}
